/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Refineexamplewarmlightprompt4Inputs */

const en_refineexamplewarmlightprompt4 = /** @type {(inputs: Refineexamplewarmlightprompt4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add warm evening light to the scene`)
};

const de_refineexamplewarmlightprompt4 = /** @type {(inputs: Refineexamplewarmlightprompt4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bringe warmes Abendlicht ins Bild`)
};

/**
* | output |
* | --- |
* | "Add warm evening light to the scene" |
*
* @param {Refineexamplewarmlightprompt4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const refineexamplewarmlightprompt4 = /** @type {((inputs?: Refineexamplewarmlightprompt4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refineexamplewarmlightprompt4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_refineexamplewarmlightprompt4(inputs)
	return de_refineexamplewarmlightprompt4(inputs)
});
export { refineexamplewarmlightprompt4 as "refineExampleWarmLightPrompt" }